import type { Layer } from '@deck.gl/core';
import type { LayerState } from '@vitals/shared';
import { buildSubwayBulletLayer } from './bullets.js';
import { citibikeRenderer } from './citibikeLayer.js';
import { flaresRenderer } from './flaresLayer.js';
import { ferryRenderer } from './ferryLayer.js';
import { busesRenderer } from './busesLayer.js';
import { camsRenderer } from './camsLayer.js';
import { linknycRenderer } from './linknycLayer.js';
import { flightsRenderer } from './flightsLayer.js';
import { floodnetRenderer } from './floodnetLayer.js';
import { eneRenderer } from './eneLayer.js';
// import { aisRenderer } from './aisLayer.js'; // ships disabled for launch
import { powerOutagesRenderer } from './powerOutagesLayer.js';
import { harborRenderer } from './harborLayer.js';
import { lirrRenderer } from './lirrLayer.js';
import { mnrRenderer } from './mnrLayer.js';
import { pathRenderer } from './pathLayer.js';
import { cablesRenderer } from './cablesLayer.js';

/** A deck.gl renderer: maps a LayerState + current time → a deck.gl Layer, an
 * ordered list of layers (drawn bottom-to-top, e.g. a ferry wake under its dots),
 * or null. */
export interface RendererDef {
  layerId: string;
  build: (state: LayerState, nowSec: number) => Layer | Layer[] | null;
}

/**
 * Registered deck.gl renderers. The rAF loop in main.ts maps this array
 * over current store states and calls overlay.setProps({ layers }).
 * Phase C/D append entries here.
 */
export const RENDERERS: RendererDef[] = [
  // Grid cables first (drawn underneath everything else — background infrastructure),
  // then stations, then buses/flares, then moving vehicles, then camera markers on
  // top (sparse, clickable).
  cablesRenderer,
  citibikeRenderer,
  busesRenderer,
  flaresRenderer,
  {
    layerId: 'subway',
    build: (state, nowSec) => buildSubwayBulletLayer(state, nowSec),
  },
  lirrRenderer,
  mnrRenderer,
  pathRenderer,
  ferryRenderer,
  camsRenderer,
  linknycRenderer,
  flightsRenderer,
  floodnetRenderer,
  eneRenderer,
  // aisRenderer, // ships disabled for launch — see server index.ts
  powerOutagesRenderer,
  harborRenderer,
];
